export const navigation = [
  {
    text: 'Clinker',
    icon: 'event',
    path: '',
    items: [
      {
        text: 'Contact List',
        path: '/bao-cao-tuan-tra',
      },
      // {
      //   text: 'B',
      //   path: '/crm-contact-details',
      // },
    ],
  },
  // {
  //   text: 'Planning',
  //   icon: 'event',
  //   path: '',
  //   items: [
  //     {
  //       text: 'Task List',
  //       path: '/planning-task-list',
  //     },
  //     {
  //       text: 'Task Details',
  //       path: '/planning-task-details',
  //     },
  //     {
  //       text: 'Scheduler',
  //       path: '/planning-scheduler'
  //     },
  //   ],
  // },
  // {
  //   text: 'Analytics',
  //   icon: 'chart',
  //   path: '',
  //   items: [
  //     {
  //       text: 'Dashboard',
  //       path: '/analytics-dashboard',
  //     },
  //     {
  //       text: 'Sales Analysis',
  //       path: '/analytics-sales-analysis',
  //     },
  //     {
  //       text: 'Geography',
  //       path: '/analytics-geography',
  //     },
  //   ],
  // },
  {
    text: 'Authentication',
    icon: 'card',
    path: '',
    items: [
      {
        text: 'Sign In Form',
        path: '/sign-in-form',
      },
      // {
      //   text: 'Register Form',
      //   path: '/register-form',
      // },
      // {
      //   text: 'Reset Password Form',
      //   path: '/reset-password-form',
      // }
    ]
  },
  // {
  //   text: 'Common',
  //   icon: 'box',
  //   path: '',
  //   items: [
  //     {
  //       text: 'User Profile',
  //       path: '/user-profile',
  //     }
  //   ]
  // },
];
